import React from 'react';
import { Heart, Target, Users, Zap } from 'lucide-react';

const About = () => {
  return (
    <div data-testid="about-page">
      {/* Hero Section */}
      <section className="section-spacing bg-gradient-to-b from-background to-muted" data-testid="about-hero">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">About Seedoza</h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            We're on a mission to revolutionize healthy snacking with the power of nature's most nutritious seeds.
          </p>
        </div>
      </section>

      {/* Our Story */}
      <section className="section-spacing">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1758274533800-6a5fe97f53f6?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Seedoza Story"
                className="rounded-3xl shadow-hover w-full h-auto"
              />
            </div>
            <div className="space-y-6">
              <h2 className="text-4xl font-heading font-bold">Our Story</h2>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Seedoza was born from a simple belief: healthy snacking should never mean compromising on taste. We started by exploring the incredible nutritional power of seeds - nature's tiny superfoods packed with protein, healthy fats, and essential minerals.
              </p>
              <p className="text-lg text-muted-foreground leading-relaxed">
                After countless experiments in our kitchen, we perfected our first product: Energy Bites that combine five powerful seeds with natural dates and dark chocolate. The result? A snack that's as delicious as it is nutritious.
              </p>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Today, we're proud to serve thousands of health-conscious individuals across India who choose Seedoza for their daily dose of natural energy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-spacing bg-muted/30">
        <div className="container-custom">
          <h2 className="text-4xl font-heading font-bold text-center mb-16">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="feature-card text-center">
              <div className="flex justify-center mb-4">
                <Heart className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3">Natural Ingredients</h3>
              <p className="text-muted-foreground">
                Only the finest natural ingredients, no artificial additives or preservatives.
              </p>
            </div>
            <div className="feature-card text-center">
              <div className="flex justify-center mb-4">
                <Target className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3">Quality First</h3>
              <p className="text-muted-foreground">
                Every batch is carefully crafted to ensure consistent taste and nutrition.
              </p>
            </div>
            <div className="feature-card text-center">
              <div className="flex justify-center mb-4">
                <Users className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3">Customer Focused</h3>
              <p className="text-muted-foreground">
                Your health and satisfaction are at the heart of everything we do.
              </p>
            </div>
            <div className="feature-card text-center">
              <div className="flex justify-center mb-4">
                <Zap className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3">Sustainable</h3>
              <p className="text-muted-foreground">
                Committed to sustainable sourcing and eco-friendly packaging.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section-spacing">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-primary text-primary-foreground rounded-3xl p-12">
              <h2 className="text-3xl font-heading font-bold mb-6">Our Mission</h2>
              <p className="text-lg leading-relaxed">
                To make healthy snacking accessible, delicious, and convenient for everyone. We create nutrient-dense snacks that fuel active lifestyles without compromising on taste.
              </p>
            </div>
            <div className="bg-secondary text-secondary-foreground rounded-3xl p-12">
              <h2 className="text-3xl font-heading font-bold mb-6">Our Vision</h2>
              <p className="text-lg leading-relaxed">
                To become India's most trusted brand for healthy snacks, inspiring a generation to choose natural, wholesome foods that nourish both body and mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section-spacing bg-gradient-to-b from-muted to-background">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-heading font-bold mb-6">Join the Seedoza Family</h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Experience the difference that real, natural ingredients can make in your daily nutrition.
          </p>
          <a href="/products">
            <button className="btn-accent" data-testid="join-cta-button">
              Explore Our Products
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
